(function () {
  var variantId = new URLSearchParams(window.location.search).get('autoselect');
  if (!variantId) return;

  var TITLES = { '47948304384192': 'Tallow Lip Balm' };
  var targetTitle = TITLES[variantId];
  if (!targetTitle) return;

  var done = false;

  function tryClick() {
    if (done) return;
    var app = document.getElementById('bundling-app');
    if (!app) return;

    var btns = app.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var btnText = btn.textContent.trim();
      // Match "Add", "+", "Add <anything>" — covers localised and icon variants
      if (btnText !== 'Add' && btnText !== '+' && !/^Add\b/.test(btnText)) continue;

      // Walk up from button, checking up to 6 ancestor levels
      var el = btn.parentElement;
      for (var j = 0; j < 6; j++) {
        if (!el || el === app) break;
        // outerHTML covers text nodes AND attribute values (alt, aria-label, data-*)
        if (el.outerHTML.includes(targetTitle)) {
          // Confirm this is a single product card: should contain only 1–2 buttons
          if (el.querySelectorAll('button').length <= 2) {
            done = true;
            obs.disconnect();
            btn.click();
            return;
          }
        }
        el = el.parentElement;
      }
    }
  }

  var obs = new MutationObserver(tryClick);

  function startObserving() {
    var app = document.getElementById('bundling-app');
    if (app) {
      obs.observe(app, { childList: true, subtree: true });
      tryClick();
    } else {
      var rootObs = new MutationObserver(function () {
        var a = document.getElementById('bundling-app');
        if (a) {
          rootObs.disconnect();
          obs.observe(a, { childList: true, subtree: true });
          tryClick();
        }
      });
      rootObs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  setTimeout(function () { obs.disconnect(); }, 15000);
})();
